const carouselItems = [
  {
    title: '暑期档 · 必追好剧',
    desc: '这个暑假，从《长相思》到《庆余年》第二季，大制作云集，每天都有新惊喜。古装玄幻、都市甜宠、悬疑推理轮番上阵，告别剧荒从此刻开始。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20evening%20cinematic%20scene%20with%20dramatic%20golden%20sunset%20sky%2C%20warm%20amber%20and%20deep%20orange%20tones%2C%20film%20projector%20light%20beam%20effect%2C%20dreamy%20atmosphere%2C%20entertainment%20and%20storytelling%20concept%2C%20epic%20cinematic%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '暑期特辑',
    badge: 'HOT',
  },
  {
    title: '古装大戏 · 视觉盛宴',
    desc: '《甄嬛传》《琅琊榜》《长相思》《庆余年》……每一部都是服化道精良、演技在线的经典之作，沉浸式感受东方美学的极致魅力。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20palace%20interior%20with%20ornate%20golden%20decorations%20and%20red%20lanterns%2C%20dramatic%20cinematic%20lighting%20with%20warm%20candlelight%20ambiance%2C%20imperial%20elegance%2C%20rich%20textures%20of%20silk%20and%20wood%2C%20majestic%20atmosphere&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '古装精选',
    badge: '精选',
  },
  {
    title: '韩剧专区 · 浪漫来袭',
    desc: '热门韩剧高清同步更新，精准中文字幕让追剧更轻松。从甜到心坎的浪漫爱情到让人心跳加速的悬疑惊悚，韩剧迷的专属天地。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20style%20scene%20with%20cherry%20blossoms%20and%20soft%20spring%20sunlight%2C%20couple%20walking%20along%20tree-lined%20path%2C%20dreamy%20atmosphere%20with%20pink%20and%20warm%20tones%2C%20cinematic%20romance%20aesthetic&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '韩剧推荐',
    badge: '热门',
  },
  {
    title: '1080P · 视觉升级',
    desc: '全站视频画质已全面升级至1080P高清，每一帧都清晰锐利。配合智能网络自适应技术，无论WiFi还是移动数据，都能获得最佳观看体验。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20high-definition%20screen%2C%20warm%20ambient%20lighting%2C%20cinematic%20viewing%20experience%2C%20dark%20elegant%20interior%20with%20subtle%20golden%20accents%2C%20premium%20entertainment%20space&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '技术升级',
    badge: 'NEW',
  },
  {
    title: '经典重温 · 永恒感动',
    desc: '《父母爱情》《琅琊榜》《亮剑》……那些曾经打动过无数人的经典老剧高清修复上线。好故事永远不会过时，一键重温那些年的感动。',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20Chinese%20living%20room%20with%20old%20television%20set%2C%20warm%20afternoon%20sunlight%20through%20lace%20curtains%2C%20retro%201980s%20aesthetic%2C%20sepia%20and%20golden%20tones%2C%20sentimental%20atmosphere%2C%20timeless%20feeling&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '经典回顾',
    badge: '珍藏',
  },
  {
    title: '全平台 · 随时随地',
    desc: 'PC、平板、手机全平台适配，在家用大屏沉浸追剧，出门手机续播不停。智能记录播放进度，切换设备无缝衔接，追剧体验从未如此自由。',
    img: 'https://readdy.ai/api/search-image?query=Multiple%20devices%20displaying%20streaming%20content%20with%20phone%20tablet%20and%20laptop%2C%20dark%20modern%20setup%20with%20warm%20accent%20lighting%2C%20cross-platform%20entertainment%20concept%2C%20clean%20minimal%20composition%2C%20tech%20lifestyle%20aesthetic&width=1200&height=600&seq=carousel-06&orientation=landscape',
    tag: '跨端体验',
    badge: '升级',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="relative py-16 md:py-20 bg-background-950">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary-500/3 rounded-full blur-3xl"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <i className="ri-lightbulb-flash-line text-primary-400 text-xs"></i>
            <span className="text-primary-300 text-xs font-medium">焦点专题</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50">
            精彩专题 · 深度推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            六大精选专题，带你深入了解最值得关注的剧集与功能
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group relative rounded-xl overflow-hidden bg-background-900 border border-background-800/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.img}
                  alt={`6080新视觉影视 ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/30 to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-[10px] font-bold">
                    {item.badge}
                  </span>
                  <span className="px-2 py-0.5 rounded-md bg-background-950/60 backdrop-blur-sm text-background-100 text-[10px]">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-bold text-base md:text-lg text-background-50 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-400 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}